import React from "react";
import check from "../assets/dashboard/check.svg";
import checkGreen from "../assets/dashboard/check-green.svg";
import { Link } from "react-router-dom";


export default function RecentActivity({ data = [], loading }) {
  function timeAgo(dateString) {
  const now = new Date();
  const past = new Date(dateString);

  const diff = Math.floor((now - past) / 1000); // seconds

  if (diff < 60) return "just now";

  const minutes = Math.floor(diff / 60);
  if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;

  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

  const days = Math.floor(hours / 24);
  return `${days} day${days > 1 ? "s" : ""} ago`;
}
  return (
    <div className=" rounded-[20px] pt-6 sm:pt-[30px] pb-8 px-5 sm:pl-7 sm:pr-6 bg-white shadow-[0_4px_4px_0_#00000040] h-full flex flex-col border border-[#EEEEEE]">
      <div className="flex items-start justify-between mb-7">
        <h3 className="text-lg sm:text-xl leading-4 sm:leading-6 text-black font-bold">
          Recent Activity
        </h3>
        <Link to="/notifications" className="text-sm sm:text-base text-[#1FA5DE] hover:underline">
          See All
        </Link>
      </div>

      <div className="flex-1 overflow-hidden">
        <ul className="space-y-[30px]">
          {loading ? (
            <div className="space-y-3">
              {[1, 2, 3, 4].map((i) => (
                <div
                  key={i}
                  className="h-10 bg-gray-200 animate-pulse rounded-md"
                />
              ))}
            </div>
          ) : (
            data.slice(0, 4).map((a, idx) => {
              const isAlert = a.type === "alert";
              const isApproval = a.type === "approval";
              return (
              <li key={idx} className="flex items-center gap-3">
                <div
                  className={`w-[35px] h-[33px] rounded flex items-center justify-center shrink-0 ${
                    isAlert ? "bg-[#FFE2E2]" : "bg-[#D8FFDF]"
                  }`}
                >
                  <img src={isAlert ? check : checkGreen} alt="icon" />
                </div>

                <div>
                  <div className="text-black text-sm font-semibold">{a.title}</div>
                  <div className="text-[#878686] text-xs leading-4">{a.message}</div>
                  <div className="text-[#878686] text-[10px] leading-4 mt-0.5">{timeAgo(a.createdAt)}</div>
                </div>
              </li>
            )})
          )}
        </ul>
      </div>
    </div>
  );
}
